import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import type { PosVoidReasonInput } from '@/api/types'
import { posVoidReasonsApi } from '@/api/endpoints/pos-void-reasons'

export function usePosVoidReasons(restaurantId: number) {
  return useQuery({
    queryKey: ['posVoidReasons', restaurantId],
    queryFn: () => posVoidReasonsApi.get(restaurantId),
    enabled: Number.isFinite(restaurantId) && restaurantId > 0,
    staleTime: 0,
  })
}

export function useSavePosVoidReasons(restaurantId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (items: Array<PosVoidReasonInput>) =>
      posVoidReasonsApi.save(restaurantId, items),
    onSuccess: () => {
      toast.success('Void reasons saved')
      qc.invalidateQueries({ queryKey: ['posVoidReasons', restaurantId] })
    },
    onError: () => {
      toast.error('Failed to save void reasons')
    },
  })
}
